import classNames from "classnames";
import React, {useCallback, useMemo, useState} from "react";
import {createStore, createStyleSet} from "botframework-webchat";
import LogoSVGComponent from "./LogoSVGComponent";

import WebChat from "./WebChat";

import "./fabric-icons-inline.css";
import "./MinimizableWebChat.css";

const MinimizableWebChat = (crmBotConfig) => {
    const store = useMemo(
        () =>
            createStore({}, ({dispatch}) => (next) => (action) => {
                if (action.type === "DIRECT_LINE/CONNECT_FULFILLED") {
                    dispatch({
                        type: "WEB_CHAT/SEND_EVENT",
                        payload: {
                            name: "webchat/join",
                            value: {
                                language: window.navigator.language,
                            },
                        },
                    });
                } else if (action.type === "DIRECT_LINE/INCOMING_ACTIVITY") {
                    if (action.payload.activity.from.role === "bot") {
                        setNewMessage(true);
                    }
                }

                return next(action);
            }),
        []
    );

    const styleSet = useMemo(
        () =>
            createStyleSet({
                backgroundColor: "Transparent",
            }),
        []
    );

    const [loaded, setLoaded] = useState(true);
    const [minimized, setMinimized] = useState(true);
    const [newMessage, setNewMessage] = useState(false);
    const [side, setSide] = useState("right");
    const [token, setToken] = useState();

    const handleFetchToken = useCallback(async () => {
        let {token, conversation_Id} = sessionStorage;

        if (!token) {
            const res = await fetch(
                "https://directline.botframework.com/v3/directline/tokens/generate",
                {
                    method: "POST",
                    headers: {
                        Authorization: "Bearer " + crmBotConfig?.config?.key,
                        conversationId: sessionStorage.conversationId,
                    },
                });

            const {token: directLineToken, conversationId} = await res.json();

            sessionStorage['token'] = directLineToken;
            sessionStorage['conversation_Id'] = conversationId
            token = directLineToken;
            conversation_Id = conversationId;
        }

        if (!conversation_Id) {
            const res = await fetch(`https://directline.botframework.com/v3/directline/conversations/${conversation_Id}`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`,
                },
            });

            let {conversationId} = await res.json();
            sessionStorage['conversation_Id'] = conversationId;
        }

        setToken(token);

    }, [setToken, crmBotConfig]);

    const handleMaximizeButtonClick = useCallback(async () => {
        setLoaded(true);
        setMinimized(false);
        setNewMessage(false);
    }, [setMinimized, setNewMessage]);

    const handleMinimizeButtonClick = useCallback(() => {
        setMinimized(true);
        setNewMessage(false);
    }, [setMinimized, setNewMessage]);

    const handleSwitchButtonClick = useCallback(() => {
        setSide(side === "left" ? "right" : "left");
    }, [setSide, side]);

    // TODO: [P2] Currently, we cannot unmount Web Chat from DOM when it is minimized.
    //       Today, if we unmount it, Web Chat will call disconnect on DirectLineJS object.
    //       When minimized, we still want to maintain that connection while the UI is gone.
    //       This is related to https://github.com/microsoft/BotFramework-WebChat/issues/2750.

    return (
        <div className="minimizable-web-chat">
            {minimized && (
                <button className="maximize" onClick={handleMaximizeButtonClick}>
                    {/* <span
            className={
              token
                ? "ms-Icon ms-Icon--MessageFill"
                : "ms-Icon ms-Icon--Message"
            }
          /> */}
                    <LogoSVGComponent/>
                    {newMessage && (
                        <span className="ms-Icon ms-Icon--CircleShapeSolid red-dot"/>
                    )}
                </button>
            )}
            {loaded && (
                <div
                    className={classNames(
                        side === "left" ? "chat-box left" : "chat-box right",
                        minimized ? "hide" : "show"
                    )}
                >
                    <header>
                        <div className="filler">
                            <span>Virtual Agent</span>
                        </div>
                        <button className="switch" onClick={handleSwitchButtonClick}>
                            <span className="ms-Icon ms-Icon--Switch"/>
                        </button>
                        <button className="minimize" onClick={handleMinimizeButtonClick}>
                            <span className="ms-Icon ms-Icon--ChromeMinimize"/>
                        </button>
                    </header>
                    <WebChat
                        className="react-web-chat"
                        onFetchToken={handleFetchToken}
                        store={store}
                        styleSet={styleSet}
                        token={token}
                    />
                </div>
            )}
        </div>
    );
};

export default MinimizableWebChat;
